import React from 'react';
import { Popover } from '@mui/material';
import { bloomberg } from '../theme/bloombergTheme';

/**
 * Shared "hover to preview, click to pin" detail popover used by the
 * simplified calendar list rows (MacroCalendar, UpcomingEarningsCalendar).
 * Callers own the open/anchor/pin state — this just renders the shell.
 */
const InfoPopover: React.FC<{
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: React.ReactNode;
}> = ({ anchorEl, onClose, children }) => (
  <Popover
    open={!!anchorEl}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
    transformOrigin={{ vertical: 'center', horizontal: 'left' }}
    disableRestoreFocus
    disableScrollLock
    // The Popover's root overlay covers the whole viewport (even though
    // invisible) and otherwise steals the mouse from the row underneath it
    // the instant it opens — that's what causes hover to flicker on/off.
    // Ignoring pointer events on the root and re-enabling them only on the
    // content is the standard fix (MUI's "Mouse Over Popover" pattern).
    sx={{ pointerEvents: 'none' }}
    slotProps={{
      paper: {
        sx: {
          pointerEvents: 'auto',
          bgcolor: bloomberg.bg.tertiary,
          border: `1px solid ${bloomberg.border.secondary}`,
          borderRadius: '6px',
          p: 1.5,
          minWidth: 220,
          maxWidth: 320,
        },
      },
    }}
  >
    {children}
  </Popover>
);

export default InfoPopover;
